module.exports = window["AWS-UI-Components-React"];